export type ArtifactsListQueryCache<T> = {
	get: (key: string) => T | undefined;
	set: (key: string, data: T) => void;
	delete: (key: string) => void;
};

export function createArtifactsListQueryCache<T>(): ArtifactsListQueryCache<T> {
	const cache = new Map<string, T>();
	return {
		get: (key) => cache.get(key),
		set: (key, data) => {
			cache.set(key, data);
		},
		delete: (key) => {
			cache.delete(key);
		},
	};
}

export function artifactsListQueryCacheKey(
	params: Record<string, unknown>,
): string {
	return JSON.stringify(params);
}
